import Model from '../Model'

export default class StoryReport extends Model {
    // Set the resource route of the model
    resource() {
        return 'admin/story-reports'
    }
}
